var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "demographics-chart" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.sortedRegions.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _vm._v("\n            Sin datos disponibles\n        "),
          ])
        : _c(
            "div",
            { staticClass: "bars-list" },
            _vm._l(_vm.sortedRegions, function (region, index) {
              return _c("div", { key: region.region, staticClass: "bar-row" }, [
                _c(
                  "div",
                  { staticClass: "bar-label", attrs: { title: region.region } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(region.region) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bar-track" }, [
                  _c("div", {
                    staticClass: "bar-fill",
                    style: {
                      width: _vm.pct(region.cantidad, _vm.maxValue) + "%",
                      background: _vm.colorFor(index),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bar-total" }, [
                  _vm._v(_vm._s(region.cantidad)),
                ]),
              ])
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-header" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-map-marked-alt text-primary" }),
        _vm._v("\n                Distribución Regional\n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }